import { render, staticRenderFns } from "./GeneralPopup.vue?vue&type=template&id=0243a6fc&scoped=true&"
import script from "./GeneralPopup.vue?vue&type=script&lang=js&"
export * from "./GeneralPopup.vue?vue&type=script&lang=js&"
import style0 from "./GeneralPopup.vue?vue&type=style&index=0&id=0243a6fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0243a6fc",
  null
  
)

export default component.exports